<nb-card [nbSpinner]="loading" nbSpinnerStatus="info">
  <nb-card-header>
    <div class="row">
      <div class="col-12 header">
        <h6 class="text-primary">
          <span *ngIf="product.barcode" class="text-info"
            >{{ product.barcode }} -
          </span>
          {{ product.title }}
          <span *ngIf="product.unitName" class="text-hint"
            >({{ product.unitName }})
          </span>
        </h6>

        <div>
          <a
            *ngIf="
              shopService.shop.isArchived &&
              shopService.shop.shopIdArchived &&
              product.shopIdArchived &&
              product.archivedId !== ''
            "
            (click)="archiveData()"
            class="link text-link"
          >
            <nb-icon icon="calendar-outline"></nb-icon>
            Xem dữ liệu cũ
          </a>
          <a
            *ngIf="
              shopService.shop.isArchived &&
              shopService.shop.shopIdArchived &&
              product.shopIdArchived &&
              product.archivedId !== ''
            "
            (click)="calculateProductStats(true)"
            class="link text-danger"
          >
            <nb-icon icon="calendar-outline"></nb-icon>
            Tính lại tồn kho
          </a>
          <button
            class="cancel"
            nbButton
            outline
            status="info"
            size="small"
            (click)="cancel()"
          >
            <nb-icon icon="close-outline"></nb-icon>
          </button>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-12 header">
        <ngx-card-value-overview
          [title]="'warehouse.receive' | translate"
          [value]="product.receiveAmount"
          [quantity]="product.receiveQuantity"
          [type]="'info'"
          [icon]="'arrow-circle-up-outline'"
        >
        </ngx-card-value-overview>

        <ngx-card-value-overview
          [title]="'warehouse.issue' | translate"
          [value]="product.issueAmount"
          [quantity]="product.issueQuantity"
          [type]="'warning'"
          [icon]="'arrow-circle-down-outline'"
        >
        </ngx-card-value-overview>

        <ngx-card-value-overview
          [title]="'warehouse.balance' | translate"
          [value]="product.balanceAmount"
          [quantity]="product.balanceQuantity"
          [type]="'primary'"
          [icon]="'trending-up-outline'"
        >
        </ngx-card-value-overview>
      </div>
    </div>

    <div class="row">
      <div class="col-12 form-inline">
        <ngx-view-time-period
          (periodChange)="selectTime($event)"
          [allowAll]="
            user.admin ||
            (shopService.shop.isArchived && shopService.shop.shopIdArchived)
          "
          [mode]="'inventory'"
        ></ngx-view-time-period>
        <nb-form-field fullWidth>
          <nb-icon nbPrefix icon="search-outline" pack="eva"></nb-icon>
          <input
            type="text"
            nbInput
            fullWidth
            shape="semi-round"
            class="form-control"
            status="info"
            placeholder="{{ 'common.strSearch' | translate }}"
            [(ngModel)]="strSearch"
            #search
          />
        </nb-form-field>

        <button
          nbButton
          hero
          shape="semi-round"
          status="info"
          size="small"
          (click)="receiveInventory()"
        >
          <nb-icon icon="arrow-circle-up-outline"></nb-icon>
          {{ "buttons.receive" | translate }}
        </button>

        <button
          nbButton
          hero
          shape="semi-round"
          status="warning"
          size="small"
          (click)="issueInventory()"
        >
          <nb-icon icon="arrow-circle-down-outline"></nb-icon>
          {{ "buttons.issue" | translate }}
        </button>
      </div>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="table-responsive">
      <table class="table table-striped">
        <thead class="thead-light">
          <tr>
            <th scope="col">#</th>
            <th scope="col">{{ "common.date" | translate }}</th>
            <th scope="col">{{ "common.description" | translate }}</th>
            <th scope="col" class="col-number">
              {{ "warehouse.receiveQty" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.receiveAmount" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.issueQty" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.issueAmount" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.balanceQty" | translate }}
            </th>
            <th scope="col" class="col-number">
              {{ "warehouse.balanceAmount" | translate }}
            </th>
            <th scope="col" class="col-action"></th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let item of inventories | filter: strSearch; let i = index"
          >
            <td class="col-no">
              <b class="text-info">
                {{ i + 1 }}
              </b>
              <button
                *ngIf="
                  !item.receiptId &&
                  !item.purchaseId &&
                  item.comment !== 'Đầu kỳ'
                "
                nbButton
                ghost
                status="danger"
                size="small"
                (click)="remove(item)"
              >
                <nb-icon icon="close-circle-outline"></nb-icon>
              </button>
            </td>
            <td>
              {{ item.issueDate | date: "dd/MM/yyyy" }}
            </td>
            <td>
              <span
                *ngIf="!item.receiptId && !item.purchaseId"
                class="description"
                >{{ item.comment }}
              </span>
              <a
                *ngIf="item.receiptId || item.purchaseId"
                (click)="openDetail(item)"
                class="text-primary link text-link"
              >
                {{ item.comment }}
              </a>
            </td>
            <td class="col-number">
              {{ item.receiveQuantity | number }}
            </td>
            <td class="col-number">
              {{ item.receiveAmount | number }}
            </td>
            <td class="col-number">
              {{ item.issueQuantity | number }}
            </td>
            <td class="col-number">
              {{ item.issueAmount | number }}
            </td>
            <td class="col-number">
              <strong> {{ item.balanceQuantity | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ item.balanceAmount | number }} </strong>
            </td>

            <td class="col-action">
              <button
                *ngIf="
                  !item.receiptId &&
                  !item.purchaseId &&
                  item.comment !== 'Đầu kỳ'
                "
                nbButton
                ghost
                shape="round"
                status="primary"
                size="small"
                (click)="onEdit(item)"
              >
                <nb-icon icon="edit-2-outline"></nb-icon>
              </button>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr>
            <td class="col-no" colspan="3">
              <b class="text-info"> Tổng cộng </b>
            </td>
            <td class="col-number">
              <strong> {{ receiveQuantity | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ receiveAmount | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ issueQuantity | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ issueAmount | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ balanceQuantity | number }} </strong>
            </td>
            <td class="col-number">
              <strong> {{ balanceAmount | number }} </strong>
            </td>

            <td class="col-action"></td>
          </tr>
        </tfoot>
      </table>
    </div>
  </nb-card-body>
</nb-card>
